import React, { useEffect, useState } from 'react';
import { Container, Button, Card, Form, Row, Col } from 'react-bootstrap';
import ActionRequestService from '../../../services/action-request';
import ResalesRequestService from '../../../services/resales-request';
import {
  FlowType,
  FundType,
  ActionType,
  ActionStatus,
} from '../../../helpers/Enum/index';
import Params from '../../../helpers/Params';
import DatePicker from 'react-datepicker';
import Currency, { currencyReverse } from 'helpers/Currency';
import 'react-datepicker/dist/react-datepicker.css';
// import Historic from '../../../components/Historic';
import FileUploadMultiple from 'components/FileUploadMultiple';
import {
  WidgetsOutlined,
  ArrowBackIos,
  ErrorOutlineOutlined,
} from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Unauthorized from 'components/Unauthorized';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router';
import Swal from 'sweetalert2';
import Alert from '../../../helpers/alert';

import '../style.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';

import FormatDate from 'helpers/FormatDate';
import SelectFiscalYears from 'components/SelectFiscalYears';

import ShowV1 from './ShowV1';
import ShowV2 from './ShowV2';
import { useProfile, useUser, useCompany } from 'models';
import Loading from 'components/Loading';

export default function(){
  const user = useUser()
  const {company:currentCompany} = useCompany()
  const profile = useProfile()

  const [actionId, setActionId] = useState(Params.get('id'));
  const [action, setAction] = useState({});
  const [actionAux, setActionAux] = useState(null);
  const [actionValue, setActionValue] = useState({});
  const [isVerifing, setIsVerifing] = useState(false)

  const [listFiscalYear, setListFiscalYear] = useState(
    currentCompany ? currentCompany.fiscal_years_elite : [{ id: 9, fiscal_year: "2021" }]
  );
  const [fiscalYear, setFiscalYear] = useState(
    currentCompany && currentCompany.fiscal_years_elite ?
      currentCompany.fiscal_years_elite.length > 1 ? currentCompany.fiscal_years_elite[1].id : currentCompany.fiscal_years_elite[0].id
      : 5
  );
  const [companyId, setCompanyId] = useState(
    currentCompany
      ? currentCompany.id
      :  user.currentCompany ? user.currentCompany.id : '');

  const [file, setFile] = useState([]);
  const [filecomments, setFilecomments] = useState([]);

  const [bus, setBus] = useState([]);
  const [flow, setFlow] = useState(null);
  const [categories, setCategories] = useState([]);

  const [rodando, setRodando] = useState(true);

  const [demonstrative, setDemonstrative] = useState(null);
  const [status, setStatus] = useState(null);
  const [steps, setSteps] = useState([]);
  const [statusId, setStatusId] = useState(null);

  const [editable, setEditable] = useState(true);

  const [fundsMobileCollapsed, setFundsMobileCollapsed] = useState(true);

  const { t } = useTranslation();

  const history = useHistory();

  const [actionToShow, setActionToShow] = useState(); // Ação executada [rejeitada, cancelada, autorizada,...]
  const [bu_enabled, setBuEnabled] = useState([]);  
  const [fund_enabled, setFundEnabled] = useState([]);

  useEffect(() => {
    getBus();
    getFlow();
    getCategories();
    if (actionId) getAction();
    setValue(
      'fiscal_year_id',
      currentCompany && currentCompany.fiscal_years_elite ?
        currentCompany.fiscal_years_elite.length > 1 ? currentCompany.fiscal_years_elite[1].id : currentCompany.fiscal_years_elite[0].id
        : 5
    );
  }, []);

  // useEffect(() => {
  //   if (action.id && flow && rodando && user) {
  //     let aux_status = Object.values(flow.action_status).filter(
  //       (status) => status.id === statusId
  //     )[0];
  //     setStatus(aux_status);
  //     let aux_steps = user.routes.filter((r) => r.alias === 'rebate.edit')[0]
  //       .flow.user_steps;
  //     setSteps(
  //       Object.values(aux_steps).filter(
  //         (a) => a.action_status_id === aux_status.id
  //       )[0]
  //         ? aux_status.next_steps
  //         : null
  //     );

  //     if (
  //       aux_status.id != ActionStatus().AcaoRejeitada ||
  //       !Object.values(aux_steps).filter(
  //         (a) => a.action_status_id === aux_status.id
  //       )[0]
  //     )
  //       setEditable(false);
  //     setRodando(false);
  //   } else if (flow && rodando) {
  //     setSteps(
  //       Object.values(flow.action_status).filter(
  //         (f) => f.id === flow.action_status_id
  //       )
  //     );
  //   }
  // }, [action, flow, user]);

  // useEffect(() => {
  //   if (action.id) loadDemonstrative(action);
  //   else loadDemonstrative(null);
  // }, [fiscalYear]);

  const getAction = () => {
    setIsVerifing(true)
    let request = ActionRequestService.get(actionId, {
      params: {
        embed:
          'action_histories.user,action_histories.action_status,files,funds,company',
      },
    });
    request.then((data) => {
      let aux_action = data.data.data;
      if ([2,3].includes(aux_action.type_id)) {
        //window.location.href = `/elite/scancash/show/${aux_action.id}`
        history.push(`/elite/scancash/show/${aux_action.id}`)
      }
      setFiscalYear(aux_action.fiscal_year_id);
      aux_action.company.fiscal_years_elite.length > aux_action.company.group_years ? 
        setListFiscalYear(aux_action.company.fiscal_years_elite) : 
        setListFiscalYear(aux_action.company.group_years);
      setStatusId(aux_action.action_status_id);
      // aux_action.start_at = new Date(FormatDate.parseDate(aux_action.start_at));
      // aux_action.end_at = new Date(FormatDate.parseDate(aux_action.end_at));
      aux_action.estimated_pay_date = aux_action.estimated_pay_date
        ? new Date(FormatDate.parseDate(aux_action.estimated_pay_date))
        : '';
      aux_action.pay_date = aux_action.pay_date
        ? new Date(FormatDate.parseDate(aux_action.pay_date))
        : '';
      // loadDemonstrative(aux_action);
      setCompanyId(aux_action.company_id);
      changeFiscalYear(aux_action.fiscal_year_id);
      setAction(aux_action);
      setActionAux(aux_action);
    }).finally(() => setIsVerifing(false));
  };

  const getBus = () => {
    let request = ActionRequestService.getBusinessUnities({
      params: {
        embed: 'funds|type_id=' + FundType().Rebate,
      },
    });
    request.then((data) => {
      setBus(data.data.data);
    });
  };

  const getFlow = () => {
    let request = ActionRequestService.getFlow(FlowType.Rebate);
    request.then((data) => {
      setFlow(data.data.data);
    });
  };

  const getCategories = () => {
    let request = ActionRequestService.getCategories({
      params: {
        embed: 'subcategories',
      },
    });
    request.then((data) => {
      setCategories(data.data.data);
    });
  };

  const loadDemonstrative = (action, fiscal_year_id = null, company_id = null) => {
    const buildDemonstrative = (fund) => {
      let actions = fund.actions;
      let actionsPaid = actions.filter((a) => {
        return (
          a.action_status_id === ActionStatus().Finalizada &&
          a.action_status_id !== ActionStatus().Cancelada
        );
      });
      let runningActions = actions.filter((a) => {
        return (
          a.action_status_id !== ActionStatus().Finalizada &&
          a.action_status_id !== ActionStatus().Cancelada
          && !(a.action_status_id == ActionStatus().AcaoRejeitada && Params.get('id') && a.id === parseInt(Params.get('id')))
        );
      });

      let spending = actionsPaid.reduce((total, value) => {
        return total + value.pivot.value;
      }, 0);
      let spendingPlanned = runningActions.reduce((total, value) => {
        return total + value.pivot.value;
      }, 0);

      let freeFund = parseFloat(fund.pivot.value) - parseFloat(spending) - parseFloat(spendingPlanned)

      return {
        id: fund.id,
        bu: fund.business_unity_id,
        name: fund.alias,
        key: fund.name,
        freeFund: (parseFloat(freeFund.toFixed(2)) <= 0 && action) || freeFund.toFixed(2)=='-0.00' ? 0.00 : parseFloat(freeFund.toFixed(2)),
      };
    };

    if (!actionId && currentCompany == null) return showMessageErro();

    if (actionId) {
      let request = ActionRequestService.get(actionId, {
      });
      request.then((data) => {
        let company_id = data.data.data.company_id;
        if (company_id) {
          let filters = {
            embed: 'actions',
            type_id: 2,
            fiscal_year_id: action ? action.fiscal_year : fiscalYear
          };
          let request = ResalesRequestService.getCompanyFunds(company_id, {
            params: { ...filters },
          });
          request.then((data) => {
            let result = data.data.data;
            let demonstrative = [];
            result.funds.forEach((fund, key) => {
              demonstrative[key] = buildDemonstrative(fund);
            });
            demonstrative = groupBy(demonstrative, 'bu');
            let bus_aux = []
            Object.values(demonstrative).forEach(a => {
              a.map(b => bus_aux.push(b.bu));
            });
            setBuEnabled(bus_aux);
            setDemonstrative(Object.values(demonstrative));
          });
        }
      });
    } else {
      let company_id = companyId ?? company_id;
      if (company_id) {
        let filters = {
          embed: 'actions',
          type_id: 2,
          fiscal_year_id: action ? action.fiscal_year : fiscal_year_id ?? fiscalYear
        };
        let request = ResalesRequestService.getCompanyFunds(company_id, {
          params: { ...filters },
        });
        request.then((data) => {
          let result = data.data.data;
          let demonstrative = [];
          result.funds.forEach((fund, key) => {
            let aux_fund = buildDemonstrative(fund);
            if (aux_fund.freeFund > 0 || profile.havePermission('rebate.overflow-value'))
              demonstrative[key] = aux_fund;
          });
          demonstrative = groupBy(demonstrative, 'bu');
          let bus_aux = []
          Object.values(demonstrative).forEach(a => {
            a.map(b => bus_aux.push(b.bu));
          });
          setBuEnabled(bus_aux);
          setDemonstrative(Object.values(demonstrative));
        });
      }
    }
  };

  const groupBy = function (xs, key) {
    return xs.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };

  const setCheckedFund = (fundId, actionFunds, k) => {
    let aux_action_value = { ...actionValue };
    if (actionFunds.filter((af) => af.id === fundId)[0]) {
      if (!aux_action_value[k] && aux_action_value[k] !== null) {
        aux_action_value[k] = {};
        aux_action_value[k].id = actionFunds.filter((af) => af.id === fundId)[0].id;
        aux_action_value[k].pivot = actionFunds.filter((af) => af.id === fundId)[0].pivot;
        setActionValue({ ...aux_action_value });
      }
    }
    return aux_action_value[k];
  }

  const changeFiscalYear = (id) => {
    const filter = {
      fiscal_year_id: id,
      company_id: companyId
    };
    let companies = ResalesRequestService.getGroupHeadquarter({
      params: { ...filter },
    });
    companies.then((data) => {
      let c = data.data.data;
      setCompanyId(data.data.data.company_id)
      setFiscalYear(id);
    });
  }

  const getFormBu = () => {
    if (action.id) {
      let actionFunds = Object.values(action.funds);
      let buKey = bus.filter(
        (b) => b.id === action.funds[0].business_unity_id
      )[0];
      let bu = bus.filter((b) => b.id === buKey.id)[0];
      if (bu)
        return (
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>Selecione o Fundo</Form.Label>
                {bu.funds.map((fund, k) => {
                  return (
                    <Row key={k}>
                      <Col xs={6}>
                        <Form.Group>
                          <Form.Check
                            type="checkbox"
                            checked={
                              setCheckedFund(fund.id, actionFunds, k)
                              // actionFunds.filter((af) => af.id === fund.id)[0]
                            }
                            disabled={!editable}
                            label={fund.alias}
                            onChange={(e) => {
                              let isChecked = e.currentTarget.checked;
                              let aux_action_value = { ...actionValue };
                              if (isChecked) {
                                aux_action_value[k] = {};
                                aux_action_value[k].id = fund.id;
                                aux_action_value[k].pivot = {};
                                aux_action_value[k].pivot.value = '';
                              } else {
                                aux_action_value[k] = null;
                              }
                              setActionValue({ ...aux_action_value });
                            }}
                          />
                        </Form.Group>
                      </Col>
                      <Col key={k} xs={6}>
                        <Form.Group>
                          <Form.Label>Valor</Form.Label>
                          <Currency
                            value={
                              actionValue[k] ? actionValue[k].pivot.value : ''
                              // actionFunds.filter((af) => af.id === fund.id)[0]
                              //   ? actionFunds.filter(
                              //     (af) => af.id === fund.id
                              //   )[0].pivot.value
                              //   : ''
                            }
                            disabled={!actionValue[k] ? true : !editable}
                            onChange={(e) => {
                              let aux_action_value = { ...actionValue };
                              if (aux_action_value[k]) {
                                let value_aux = currencyReverse(e.target.value);
                                demonstrative.forEach(element => {
                                  element.forEach(f=>{
                                    if(aux_action_value[k].id == f.id){
                                      if(value_aux > f.freeFund && !profile.havePermission('rebate.overflow-value')) {
                                        value_aux = f.freeFund > 0 ?f.freeFund:0;
                                      }
                                    }
                                  })
                                });
            
                                aux_action_value[
                                  k
                                ].pivot.value = value_aux;
                                setActionValue({ ...aux_action_value });
                              }
                            }}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  );
                })}
              </Form.Group>
            </Col>
          </Row>
        );
    } else {
      let bu = bus.filter((b) => b.id == getValue('bu'))[0];
      if (bu)
        return (
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>Selecione o Fundo</Form.Label>
                {bu.funds.filter((fund, k) => {
                  let fund_aux = []
                  demonstrative.forEach(a => {
                    return a.forEach(b => {
                      if (b.bu == getValue('bu'))
                        fund_aux.push(b.key);
                    })
                  })
                  if(fund_aux.indexOf(fund.name) == -1) return false;
                  return true;
                }).map((fund, k) => {
                  return (
                    <Row key={k}>
                      <Col xs={6}>
                        <Form.Group>
                          <Form.Check
                            type="checkbox"
                            checked={true}
                            disabled={true}
                            label={fund.alias}
                            onChange={(e) => {
                              let isChecked = e.currentTarget.checked;
                              let aux_action_value = { ...actionValue };
                              if (isChecked) {
                               aux_action_value[k] = {};
                               aux_action_value[k].id = fund.id;
                               aux_action_value[k].pivot = {};
                               aux_action_value[k].pivot.value = '';
                              } else {
                               aux_action_value[k] = null;
                              }
                              setActionValue({ ...aux_action_value });
                            }}
                          />
                        </Form.Group>
                      </Col>
                      <Col key={k} xs={6}>
                        <Form.Group>
                          <Form.Label>Valor</Form.Label>
                          <Currency
                            value={
                              actionValue[k] ? actionValue[k].pivot.value : ''
                            }
                            //disabled={!actionValue[k] ? true : !editable}
                            onChange={(e) => {
                              if (e.target.value == "") {
                                e.target.value = '0,00'
                              }
                              let aux_action_value = { ...actionValue };
                              if (aux_action_value[k]) {
                                let value_aux = currencyReverse(e.target.value);
                                demonstrative.forEach(element => {
                                  element.forEach(f =>{
                                    if(aux_action_value[k].id == f.id){
                                      if(value_aux > f.freeFund && !profile.havePermission('rebate.overflow-value')) {
                                        value_aux = f.freeFund > 0 ?f.freeFund:0;
                                      }
                                    }
                                  })
                                });
                                aux_action_value[k].pivot.value = value_aux
                                setActionValue({ ...aux_action_value });
                              } else {
                                aux_action_value[k] = {
                                  pivot: {
                                    value: currencyReverse(e.target.value),
                                  },
                                  id: fund.id,
                                };
                                setActionValue({ ...aux_action_value });
                              }
                            }}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  );
                })}
              </Form.Group>
            </Col>
          </Row>
        );
    }
  };

  const submit = (e) => {
    const btndisabled = (disabled) => {
      let btns = document.getElementsByClassName('btnsubmit');
      for (let index = 0; index < btns.length; index++) {
        const element = btns[index];
        element.disabled = disabled;
      }
    };
    e.preventDefault();
    btndisabled(true);
    let erro = { status: false, erros: [] };
    if (action.id && action.action_status_id === actionAux.action_status_id) {
      erro.status = true;
      erro.erros.push('status required');
    }
    const isRequired = (key) => {
      if (action.step)
        return action.step.fields.map((a) => a.model_field === key)[0];
      return false;
    };
    let required = [
      { key: 'action_history_description' },
      { key: 'bu', required: true, label: 'BU' },
      { key: 'title', required: true, label: 'Nome' },
      {
        key: 'estimated_pay_date',
        required: isRequired('estimated_pay_date'),
        label: 'data',
      },
      { key: 'pay_date', required: isRequired('pay_date'), label: 'data' },
      { key: 'description', required: true, label: 'Descrição' },
      { key: 'action_status_id', required: true },
    ];
    const formData = new FormData();
    formData.append('user_id', user.id);
    formData.append('company_id', companyId);
    formData.append('id', action.id ? action.id : '');
    formData.append('action_type_id', ActionType().Rebate);
    formData.append('fiscal_year_id', fiscalYear);

    file.forEach((f, k) => {
      formData.append('file[' + k + ']', f);
      formData.append('filecomments[' + k + ']', filecomments[k].value);
    });

    const formatDate = (date) => {
      return (
        date.getUTCFullYear() +
        '-' +
        ('00' + (date.getUTCMonth() + 1)).slice(-2) +
        '-' +
        ('00' + date.getUTCDate()).slice(-2) +
        ' ' +
        ('00' + date.getUTCHours()).slice(-2) +
        ':' +
        ('00' + date.getUTCMinutes()).slice(-2) +
        ':' +
        ('00' + date.getUTCSeconds()).slice(-2)
      );
    };

    required.forEach((k) => {
      if (k.required) {
        if (
          action[k.key] &&
          action[k.key] !== '' &&
          action[k.key] !== null &&
          action[k.key] !== 0
        )
          if (k.key !== 'estimated_pay_date' && k.key !== 'pay_date')
            formData.append(k.key, action[k.key]);
          else {
            formData.append(k.key, formatDate(action[k.key]));
          }
        else {
          if (k.key === 'bu') {
            if (!action.id) {
              erro.status = true;
              erro.erros.push(k.label);
            }
          } else {
            erro.status = true;
            erro.erros.push(k.label);
          }
        }
      } else {
        if (k.key !== 'estimated_pay_date' && k.key !== 'pay_date')
          formData.append(k.key, action[k.key] ? action[k.key] : '');
        else
          formData.append(
            k.key,
            action[k.key] ? formatDate(action[k.key]) : ''
          );
      }
    });


    let bu = bus.filter((b) => b.id == getValue('bu'))[0];
    if (bu) {
      let erroBu = true;
      bu.funds.filter((fund, k) => {
        let fund_aux = []
        demonstrative.forEach(a => {
          return a.forEach(b => {
            if (b.bu == getValue('bu'))
              fund_aux.push(b.key);
          })
        })
        if(fund_aux.indexOf(fund.name) == -1) return false;
        return true;
      }).forEach((fund, k) => {
        let dem = demonstrative.filter(a => {
          return a.filter(b => b.bu == fund.business_unity_id)[0];
        })[0];
        //let dem = demonstrative[fund.business_unity_id - 1];
        if (
          actionValue[k] &&
          actionValue[k].pivot.value &&
          actionValue[k].pivot.value !== '' &&
          actionValue[k].pivot.value !== null &&
          actionValue[k].pivot.value > 0
        ) {
          if (
            dem[k].freeFund.toFixed(2) >= actionValue[k].pivot.value || 
            user.currentProfile.name === "Administrador"
          ) {
            erroBu = false;

            formData.append(
              'action_values[' + k + '][fund_id]',
              actionValue[k].id
            );
            formData.append(
              'action_values[' + k + '][value]',
              actionValue[k].pivot.value
            );
          } else {
            erroBu = false;
            erro.status = true;
            erro.erros.push('Valor não pode ser maior do que o fundo disponível');
          }
        }
      });
      if (erroBu) {
        erro.status = true;
        erro.erros.push('Fundos');
      }
    } else {
      if (!action.id) {
        erro.status = true;
        // erro.erros.push("BU");
      }
    }

    if (action.id) {
      formData.append('_method', 'put');
      // let actionFunds = Object.values(action.funds);
      let buKey = bus.filter(
        (b) => b.id === action.funds[0].business_unity_id
      )[0];
      let bu = bus.filter((b) => b.id === buKey.id)[0];
      bu.funds.forEach((fund, k) => {
        //let dem = demonstrative[fund.business_unity_id - 1];
        let dem = demonstrative.filter(a => {
          return a.filter(b => b.bu == fund.business_unity_id)[0];
        })[0];
        // let action_value = action.funds.filter((f) => f.id === fund.id)[0];
        if (actionValue[k]) {
          if (
            dem[k].freeFund.toFixed(2) >= actionValue[k].pivot.value ||
            user.currentProfile.name === 'Administrador'
            || (statusId !== ActionStatus().AcaoRejeitada && dem[k].freeFund.toFixed(2) <= actionValue[k].pivot.value)
          ) {
            formData.append('action_values[' + k + '][fund_id]', actionValue[k].id);
            formData.append(
              'action_values[' + k + '][value]',
              actionValue[k].pivot.value
            );
            if (actionValue[k].pivot.id) {
              formData.append(
                'action_values[' + k + '][id]',
                actionValue[k].pivot.id
              );
            }
          } else {
            erro.status = true;
            erro.erros.push('O valor não pode ser maior do que o fundo disponível');
          }
        }
      });
    }

    if (!erro.status) {
      let request = actionId
        ? ActionRequestService.update(actionId, formData)
        : ActionRequestService.create(formData);

      request.then((data) => {
        setActionToShow(actionId ? "Atualizado" : "Solicitado");

        Alert.success(`${actionToShow} com sucesso`).then((result) => {
          if (result.dismiss === Swal.DismissReason.timer) {
            history.push('/elite/rebate');
          }
        })
        //window.location.href = '/elite/rebate';
      });
    } else {
      erro.erros.map((e) => {
        toast.error(e, {
          autoClose: 5000,
        });
      });
      btndisabled(false);
    }
  };

  const getValue = (name) => {
    return action[name] ? action[name] : '';
  };

  const setValue = (name, value) => {
    let action_aux = { ...action };
    action_aux[name] = value;
    setAction({ ...action_aux });
  };

  const isAllowedToSendFiles = (status) => {
    let allowedStatus = [
      ActionStatus().EmExecucao,
      ActionStatus().EvidenciasAprovadas,
      ActionStatus().NFAprovada,
      ActionStatus().NFRejeitada,
      ActionStatus().AguardandoPagamento,
      ActionStatus().Finalizada,
      ActionStatus().NFsAprovada,
    ];

    return allowedStatus.indexOf(status) !== -1;
  };

  const showMessageErro = () => {
    return <Unauthorized />;
  };

  const showMessageErro2 = () => {
    return (
      <>
        <Container>
          <Row>
            <Col className="col-12 d-flex justify-content-center my-5">
              <Card.Body className="shadow bg-white rounded text-center m-2 col-9 pt-5">
                <Row className="text-center row">
                  <Col xs="12">
                    <ErrorOutlineOutlined className="icon-title" />
                    <h5 className="title-dashboard">Atenção!</h5>
                  </Col>
                </Row>
                <Row>
                  <Col className="col-12 align-self-center p-3">
                    <h5 className="text-black px-4">
                      Período de bloqueio para solicitação de novos resgates.
                    </h5>
                    <h5 className="text-black px-4">
                      A partir do dia primeiro do mês seguinte o sistema será
                      reaberto para novas solicitações.
                    </h5>
                    <h5 className="text-black mb-4 px-4">
                      Dúvidas consulte a seção de Perguntas e Respostas{' '}
                      <a href="../../faq">(FAQ)</a>.
                    </h5>
                  </Col>
                </Row>
              </Card.Body>
            </Col>
          </Row>
        </Container>
      </>
    );
  };

  const createField = (fields, action, steps) => {
    const getTemplate = (field) => {
      let retorno = <></>;
      switch (field.component.name) {
        case 'Date':
          retorno = (
            <>
              <Col xs="12" md="4">
                <Form.Group>
                  <Form.Label>{t('label:' + field.label)}</Form.Label>
                  <DatePicker
                    disabled={field.editable && steps ? false : true}
                    selected={getValue(field.name)}
                    onChange={(e) => setValue(field.name, e)}
                    className="form-control"
                  />
                </Form.Group>
              </Col>
            </>
          );
          break;
        default:
          break;
      }
      return retorno;
    };

    fields = fields.sort(function (a, b) {
      if (a.order === b.order) {
        return 0;
      }
      return a.order < b.order ? -1 : 1;
    });

    return (
      <>
        {fields.map((f, k) => {
          return <>{getTemplate(f)}</>;
        })}
      </>
    );
  };
  const getDay = () => {
    let a = new Date();
    return a.getDate();
  };

  const getProfile = () => {
    return localStorage.getItem('profile');
  };

  const getTamanho = (tamanho) => {
    return window.innerWidth <= tamanho;
  }

  const renderForm = () => {
    if(actionId){
      if(actionAux && actionAux.fiscal_year_id <= 9){
        return <ShowV1 
        action_aux={actionAux}
        bus_aux={bus}
        flow_aux={flow}
        categories_aux={categories}
        />;
      }
    }
    return <ShowV2 
    action_aux={actionAux}
    bus_aux={bus}
    flow_aux={flow}
    categories_aux={categories}
    />;
  }

  return (<>
    {isVerifing ? <Loading page /> : (<>
      {actionId || currentCompany ? (
        getDay() > 20 &&
          getDay() <= 31 &&
          !actionId &&
          getProfile() != 'Administrador' ? (
            showMessageErro2()
          ) : (
            renderForm()
          )
      ) : (
        showMessageErro()
      )}
    </>)}
  </>);
};
